import { INVESTOR_SUB_MENU_ITEMS } from '@/domains/investor/components/SubMenu/SubMenu.consts'
import { FEATURE_FLAGS } from '@/data/featureFlags'

const navigation = [
  {
    label: 'navigation.first.aboutBS',
    children: [
      {
        label: 'navigation.second.group.label',
        link: 'navigation.second.group.link',
        external: false,
      },
      {
        label: 'navigation.second.authorities.label',
        link: 'navigation.second.authorities.link',
        external: false,
      },
      {
        label: 'navigation.second.cooperation.label',
        link: 'navigation.second.cooperation.link',
        external: false,
      },
      {
        label: 'navigation.second.esg.label',
        link: 'navigation.second.esg.link',
        external: false,
      },
      {
        label: 'navigation.second.foundation.label',
        link: 'navigation.second.foundation.link',
        external: true,
      },
      {
        label: 'navigation.second.press.label',
        link: 'navigation.second.press.link',
        external: true,
      },
      {
        label: 'navigation.second.career.label',
        link: 'navigation.second.career.link',
        external: false,
        linkToLocale: 'pl',
      },
      {
        label: 'navigation.second.esg.label',
        link: 'navigation.second.esg.link',
        external: false,
      },
      {
        label: 'navigation.second.abroad.label',
        link: 'navigation.second.abroad.link',
        external: false,
      },
    ],
  },
  {
    label: 'navigation.first.products',
    children: [
      {
        label: 'navigation.second.multisport.label',
        link: 'navigation.second.multisport.link',
        external: false,
      },
      {
        label: 'navigation.second.multilife.label',
        link: 'navigation.second.multilife.link',
        external: false,
      },
      {
        label: 'navigation.second.multibilet.label',
        link: 'navigation.second.multibilet.link',
        external: false,
      },
      {
        label: 'navigation.second.multiteatr.label',
        link: 'navigation.second.multiteatr.link',
        external: false,
      },
      {
        label: 'navigation.second.myBenefit.label',
        link: 'navigation.second.myBenefit.link',
        external: false,
      },
      {
        label: 'navigation.second.wbs.label',
        link: 'navigation.second.wbs.link',
        external: false,
      },
    ],
  },
  {
    label: 'navigation.first.solutions.label',
    children: [
      {
        label: 'navigation.first.howToWell.label',
        link: 'navigation.first.howToWell.link',
        external: false,
      },
      {
        label: 'navigation.first.wellbeing.label',
        link: 'navigation.first.wellbeing.link',
        external: false,
      },
    ],
  },
  {
    label: 'navigation.first.investors.label',
    link: 'navigation.first.investors.link',
    children: [],
    external: false,
  },
  {
    label: 'navigation.first.partners.label',
    link: 'navigation.first.partners.link',
    children: [],
    external: false,
  },
  {
    label: 'navigation.first.articles.label',
    link: 'navigation.first.articles.link',
    children: [],
    external: false,
  },
  {
    label: 'navigation.contact.label',
    link: 'navigation.contact.link',
    children: [],
    external: false,
  },
]

export const MOBILE_NAVIGATION = FEATURE_FLAGS.investorMobileSubmenu
  ? navigation.map(item =>
    item.label === 'navigation.first.investors.label'
      ? { ...item, children: INVESTOR_SUB_MENU_ITEMS, isSubMenu: true }
      : item,
  )
  : navigation

export default navigation
